import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "menu",
  "use": "menu-usage",
  "viewBox": "0 0 90 90",
  "content": "<symbol fill=\"currentColor\" viewBox=\"0 0 90 90\" id=\"menu\">\n  <path fill=\"currentColor\" d=\"M10.5 44.5c0-.891.722-1.614 1.614-1.614h67.772a1.614 1.614 0 1 1 0 3.228H12.114A1.614 1.614 0 0 1 10.5 44.5Zm0-25.818c0-.891.722-1.614 1.614-1.614h67.772a1.614 1.614 0 1 1 0 3.227H12.114a1.614 1.614 0 0 1-1.614-1.613Zm0 51.636c0-.891.722-1.614 1.614-1.614h41.954a1.614 1.614 0 0 1 0 3.228H12.114a1.614 1.614 0 0 1-1.614-1.614Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol